<template>
  <div class="news-container content">
    <div class="ui-crumbs">
      当前位置：
      <router-link to="/">首页</router-link>>
      <span>新闻动态</span>
    </div>
    <div class="news-list">
      <ul>
        <li v-for="(item,index) in newsArr" :key="index" @click="jump(item.id)">
          <div class="info">
            <h3>{{item.news_title}}</h3>
            <span>{{item.add_time}}</span>
            <p>{{item.desc}}</p>
          </div>
          <div class="img-block">
            <img v-lazy="item.news_image" alt />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {
      newsArr: [],
      page: 1,
      limit: 5,
      isLoad: false
    };
  },
  methods: {
    jump: function(newsId) {
      this.$router.push({ path: "/Detail", query: { newsId: newsId } });
    },
    loadMore: function() {
      this.isLoad = false;
      this.axios
        .get("/niuniu_api.php?action=news", {
          params: {
            page: this.page,
            limit: this.limit
          }
        })
        .then(response => {
          let res = response.data;
          if (res.errcode == 0) {
            this.newsArr = this.newsArr.concat(res.data.news);
            if (res.data.is_page) {
              this.isLoad = true;
            } else {
              this.isLoad = false;
            }
          }
        });
    }
  },
  mounted: function() {
    this.loadMore();
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          document.documentElement.scrollTop -
          window.innerHeight <=
        150;
      if (bottomOfWindow && this.isLoad) {
        this.page++;
        this.loadMore();
      }
    };
  }
};
</script>
<style scoped>
.ui-crumbs {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
}
.ui-crumbs a:hover {
  color: #e23251;
}

.news-list {
  padding: 30px 0;
}

.news-list li {
  margin-bottom: 12px;
}

.news-list li {
  padding: 27px 44px;
  background-color: #f8f8f8;
  z-index: 1;
  border-radius: 8px;
  position: relative;
  transition: all 0.3s;
  cursor: pointer;
  overflow: hidden;
}

.news-list li:hover {
  background-color: #fff;
}

.news-list .info h3 {
  font-size: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 10px;
  font-weight: bold;
}
.news-list .info span {
  font-size: 16px;
  color: #999;
  display: block;
  margin: 20px 0;
}
.news-list .info p {
  font-size: 14px;
  max-height: 42px;
  overflow: hidden;
  word-break: break-all;
}
.news-list .img-block img {
  width: 100%;
}

.news-list .img-block {
  margin-top: 20px;
}

@media (min-width: 768px) {
}
@media (min-width: 992px) {
  .news-container {
    width: 970px;
    margin: 0 auto;
  }
}
@media (min-width: 1200px) {
  .news-container {
    width: 1170px;
    margin: 0 auto;
  }
  .news-list .info {
    width: 58%;
    float: left;
  }

  .news-list .img-block {
    width: 28%;
    float: right;
    margin-top: 0;
  }
}

@media (max-width: 768px) {
  .news-list {
    padding-top: 0;
  }
  .news-list li {
    padding: 20px;
  }
}
</style>
